module.exports = __webpack_public_path__ + "static/media/Shabnam-Light.66fa9054.woff";